import { useRef } from "react";
import { Button, Card } from "react-bootstrap";
import {
  DataTable,
  GridButton,
  PageHeader,
  InputTypeConstants,
  SearchParamTypeConstants,
  getSearchField,
  getTableHeader,
} from "wup-module1-base";
import { PageTitleConstants, RoutePathConstants } from "../../Constants";
import { UserService } from "../../Services";
import { useNavigate } from "react-router-dom";
import { faPencil, faList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function QuestionnaireList() {
  const navigate = useNavigate();
  const dataTableRef = useRef();
  const groupsRef = useRef();

  function getActionButtons(value) {
    return (
      <>
        <GridButton
          id={"btnPreview" + value.id}
          color="btn-success"
          icon={faList}
          disabled={false}
          ariaLabel="Lista stron"
          title="Lista stron"
          onClick={() => navigate(`${value.id}`)}
        />
        <GridButton
          id={"btnEdit" + value.id}
          color="btn-primary"
          icon={faPencil}
          disabled={value.deleted}
          ariaLabel="Edycja ankiety"
          title="Edycja ankiety"
          onClick={() => navigate(`${RoutePathConstants.Edit}/${value.id}`)}
        />
      </>
    );
  }

  function fetchQuestionnaires() {
    return JSON.parse(sessionStorage.getItem("questionnaires"));
  }

  const handleGroupBtn = (value) => {};

  const searchFields = [
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "name",
      "Nazwa",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_EQUAL,
      "deleted",
      "Pokaż usunięte",
      InputTypeConstants.checkbox
    ),
  ];

  const tableHeaders = [
    getTableHeader("Nazwa", "name", null, true, "w-auto"),
    getTableHeader(
      null,
      null,
      "Akcje",
      false,
      "w-10",
      getActionButtons,
      "text-center"
    ),
  ];

  const getRowProps = (value) => ({
    className: value.deleted ? "row-deleted" : "",
  });

  return (
    <>
      <PageHeader content={PageTitleConstants.QuestionnaireList} />
      <Card>
        <Card.Body className="pt-4-5">
          <DataTable
            fetchData={fetchQuestionnaires}
            headers={tableHeaders}
            searchFields={searchFields}
            rowProps={getRowProps}
            ref={dataTableRef}
          >
            <Button
              variant="primary"
              onClick={() => navigate(`${RoutePathConstants.Add}`)}
            >
              Dodaj ankietę
            </Button>
          </DataTable>
        </Card.Body>
      </Card>
    </>
  );
}

export default QuestionnaireList;
